import React, { useEffect, useState, Suspense, useContext } from "react";
import AppContext from "../../../../Context/AppContext";
import { toAbsoluteUrl } from "../../../../helpers";
import ReactToPrint from "react-to-print";
import "./Print.css";
export const PrintComponent = ({ urlComponent, params }) => {
  const { changeLoading } = useContext(AppContext);

  const [FunctionalComponentToPrint, setComponentToPrint] = useState(null);
  useEffect(() => {
    loadInfo();
    // loadTicket();
  }, []);
  function loadInfo() {
    const Component = React.lazy(() => import(`../../../${urlComponent}`));
    setComponentToPrint(Component);
  }
  const componentRef = React.useRef(null);

  const onBeforeGetContentResolve = React.useRef(null);

  const [loading, setLoading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");

  const handleAfterPrint = React.useCallback(() => {}, []);

  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      resolve();
    });
  }, [setLoading, setText]);

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return (
      <div className="btnPrint__container">
        <button className="btnPrint">
          <img
            className="imgLogoMenuHeader"
            src={toAbsoluteUrl("/img/Icons/Printer.png")}
          />
          Imprimir 
        </button>
      </div>
    );
  }, []);

  return (
    <div>
      <ReactToPrint
        content={reactToPrintContent}
        documentTitle="AwesomeFileName"
        onAfterPrint={handleAfterPrint}
        onBeforeGetContent={handleOnBeforeGetContent}
        onBeforePrint={handleBeforePrint}
        removeAfterPrint
        trigger={reactToPrintTrigger}
      />
      <Suspense fallback={<div>Loading...</div>}>
        {FunctionalComponentToPrint != null && (
          <FunctionalComponentToPrint
            ref={componentRef}
            text={text}
            {...params}
          />
        )}
      </Suspense>
    </div>
  );
};
